module.exports = __webpack_public_path__ + "img/squidwards_clary.34da5db6.jpg";